const mode = import.meta.env.MODE
const apiBaseURL = mode === 'production' ? `/api` : ``

interface InterestRateData {
  products: {
    name: string
    type: string
    accountProductItems: {
      description: string
      interestRate: string
      interestRateChange: string
      validFrom: string
      previous: {
        interestRate: string
        validFrom: string
      }
      minAmount?: number
      maxAmount?: number
    }[]
  }[]
}

export async function fetchInterestRate() {
  const url = `${apiBaseURL}/interest-account-service/api/external/v1/products`

  try {
    const response = await fetch(url)
    const data: InterestRateData = await response.json()
    const savingsAccountData = data.products.find((item) => item.type === 'savings_account')
    const savingsAccountInfo = savingsAccountData?.accountProductItems.find(
      (item) => item.description === 'Sparkonto',
    )
    if (!savingsAccountInfo) throw new Error('Unable to find savings account info')
    return {
      successful: true,
      data: +savingsAccountInfo.interestRate,
    }
  } catch (err) {
    return {
      successful: false,
      data: 0,
    }
  }
}

export interface InterestRate {
  period: string
  bindingPeriod: number
  amount: string
  fromDate: string
  termsEndDate: string
  customerRate: string
  interestDays: number
  minAmount: number
  maxAmount: number
}

export interface FixedData {
  interestAmounts: InterestRate[]
}

export async function fetchInvestmentAccountRates(placementAmount: number) {
  const url = `${apiBaseURL}/interest-calculation-service/api/v1/interest-amount/investment_account`
  const body = JSON.stringify({
    amount: placementAmount,
  })
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }
  try {
    const response = await fetch(url, options)
    if (!response.ok) throw new Error('Unable to fetch')
    const data: FixedData = await response.json()
    const { interestAmounts } = data
    if (!interestAmounts) throw new Error('Unable to find interestAmounts')
    if (interestAmounts.length === 0) throw new Error('No interestAmounts found')
    return {
      successful: true,
      data: interestAmounts,
    }
  } catch (err) {
    return {
      successful: false,
      data: [],
    }
  }
}

export async function fetchFixedPrivateRates(placementAmount: number) {
  const url = `${apiBaseURL}/interest-calculation-service/api/v1/interest-amount/fixed_term_deposit`
  const body = JSON.stringify({
    amount: placementAmount,
  })
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }
  try {
    const response = await fetch(url, options)
    if (!response.ok) throw new Error('Unable to fetch')
    const data: FixedData = await response.json()
    const { interestAmounts } = data
    if (!interestAmounts) throw new Error('Unable to find interestAmounts')
    if (interestAmounts.length === 0) throw new Error('No interestAmounts found')
    return {
      successful: true,
      data: interestAmounts,
    }
  } catch (err) {
    return {
      successful: false,
      data: [],
    }
  }
}
